<template>
    <div class="pl-2 text-sm truncate">
        <span class="inline-block align-middle">
            <hts-icons
                icon-name="hi-stop-icon"
                :color="color" />
        </span>
        <span class="inline-block align-middle">
            {{ label }}
        </span>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  status: {
    type: Number,
    required: true
  }
})

const { status } = toRefs(props)

const label = computed(() => {
  if (status?.value === 1) {
    return $t('labels.readyShip')
  }

  if (status?.value === -1) {
    return $t('labels.vehicleModule.notReady')
  }
  return 'Unknown'
})

const color = computed(() => {
  if (status?.value === 1) {
    return 'green'
  }

  if (status?.value === -1) {
    return 'orange'
  }
  return 'gray'
})
</script>
